import { render } from "./LeaveComment.vue?vue&type=template&id=a9484aaa&scoped=true"
import script from "./LeaveComment.vue?vue&type=script&lang=js"
export * from "./LeaveComment.vue?vue&type=script&lang=js"

import "./leave-comment.scss?vue&type=style&index=0&id=a9484aaa&lang=scss&scoped=true"

import exportComponent from "/var/www/html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9484aaa"]])

export default __exports__